module.exports = __webpack_public_path__ + "static/media/promo-colors.d16e99f4.jpg";